<template>
  <div>
    <page-header class="mb-5" title="Admin"/>
    <div class="flex mb-5">
      <div class="col-6 pl-0">
        <div class="nav-portal student-portal">
          <p class="body-2">Enter</p>
          <h6>Lerner Maker Lab</h6>
          <button class="btn btn-gray" v-on:click="goToStudentPortal">Enter</button>
        </div>
      </div>
      <div class="col-6 pr-0">
        <div class="nav-portal reporting-portal">
          <p class="body-2">Enter</p>
          <h6>Reporting</h6>
          <router-link class="btn btn-gray" :to="{name: 'reports'}">Enter</router-link>
        </div>
      </div>
    </div>
    <div class="flex">
      <div class="offset-lg-6 col-6 pr-0">
        <div class="nav-portal resources-portal">
          <p class="body-2">Enter</p>
          <h6>Resources</h6>
          <router-link class="btn btn-gray" :to="{name: 'resources'}">Enter</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import PageHeader from '@/component/PageHeader';
  import LernerHeader from '@/component/Header';
  import { LOGIN_AS_STUDENT } from '@/store/actions/auth.actions';
  import { CHANGE_DOC_TITLE } from '@/store/actions/app.actions';

  export default {
    name: 'index',

    components: {
      LernerHeader,
      PageHeader
    },

    computed: {
      ...mapGetters([
        'pages'
      ])
    },

    created: function () {
      this.$store.dispatch(CHANGE_DOC_TITLE, {title: 'Admin', useBaseTitle: true})
    },

    methods: {
      goToStudentPortal: function () {
        this.$store
            .dispatch(LOGIN_AS_STUDENT)
            .then(() => this.$router.push({name: 'student'}));
      }
    }
  };
</script>

<style lang="scss" scoped>
  .nav-portal {
    @apply bg-grey-3;
    border-radius : 0 30px 30px 0;
    @apply p-8;

    @media (min-width: config('screens.lg')) {
      @apply py-8 px-14;
    }

    .btn {
      @apply px-11;
    }

    p {
      @apply mb-0 uppercase text-white;
    }

    h6 {
      @apply uppercase leading-none text-white mb-3;
    }

    &.student-portal {
      border-radius : 0 30px 30px 0;
      @apply bg-c1-a;
    }

    &.reporting-portal {
      border-radius : 30px 0 0 30px;
      @apply bg-c1-b;
    }

    &.resources-portal {
      border-radius : 30px 0 0 30px;
      @apply bg-lerner-green;
    }
  }
</style>
